import { BaseEntity } from 'yt-ng-framework';
export class Dokument extends BaseEntity{
    constructor(){
        super();
    }

    Vrsta: string = null;
    Datum: Date = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Vrsta = input.Vrsta;
        this.Datum = input.Datum;

        return this;
    }

    Serialize(input: Dokument){
        // input.Vrsta="U";
        return input;
    }

    GetInstance(){
        return this;
    }
}   